<template lang="pug">
#user_cancel_plan_modal_wrapper
  b-modal#cancel-user-plan(title='Freeプランに変更します。（有料プランの解約）', 'hide-footer')
    alert-error(v-if="error",msg="error_msg")
    p 有料プランが残り{{day_until_expire}}日分残っています。Freeプランに切り替えてよろしいでしょうか？
    p ※Freeプランに切り替えた時点で、有料プランの機能は使えなくなります。また、有料プランの未利用期間分の料金はご返金をしておりませんので、契約最終日まで有料プランをご利用いただくことをお勧めしております。
    .row
      .col-md-12.mb-3
        hr
        p 有料プランの解約を進める場合、アンケートに回答後に発行される解約コードを入力してください。
        p 正しい解約コードが入力されると、「解約する」ボタンのクリックができます。
        a(href="https://docs.google.com/forms/d/e/1FAIpQLSfvGTSl0ptanxqZtHZIiQnSCwMitD_-WURhNFbqooz4JBBARw/viewform?usp=sf_link", target="_blank") アンケートはこちら
      .col-md-12
        .form-group.text-sm
          label(for='code') 解約コード
            .badge.badge-primary *必須
          .input-group
            input#code.form-control(type='text',
            v-model="canselCode",
            @input="checkCode",
            placeholder='')
    .row
      .col.text-center
        template(v-if="canselSubmit && !submitting")
          button.btn.btn-success(@click="cancelPlan") 解約する
        template(v-else)
          button.btn.btn-success.disabled 解約する
  b-modal#cancel-plan-success(title='プラン変更が完了しました','hide-footer')
    p 有料プランをご利用いただき、ありがとうございました
  b-modal#cancel-plan-success-from-upper-premium(title='プラン変更が完了しました','hide-footer')
    template(v-if="isNewUi")
      p Freeプランは、サイトリードを利用できるドメイン数が1つに制限されます。
      p プラン変更に伴い、全てのドメインの利用およびサービスを停止しておりますので、利用を継続するドメインとサービスの再開をしてください。
      a(href="/users/tag_domains" style="color: white; background-color: #007bff;") 【利用再開はこちら】
    template(v-else)
      p 有料プランをご利用いただき、ありがとうございました
</template>

<script>
import Vue from 'vue'

export default {
  data(){
    return {
      submitting: false,
      canselSubmit: false,
      canselCode: '',
      error: false,
      error_msg: ""
    }
  },
  props: {
    day_until_expire: String,
    is_new_ui: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isNewUi() {
      return this.is_new_ui
    }
  },
  methods: {
    async cancelPlan(){
      if (this.submitting) return
      this.submitting = true
      this.error = false
      let oldPlanName = this.$store.state.user.plan_name;
      try{
        await this.$store.dispatch("user/destroySubscription")
        this.$bvModal.hide('cancel-user-plan')
        if (oldPlanName !== 'basic') {
          this.$bvModal.show('cancel-plan-success-from-upper-premium')
        } else {
          this.$bvModal.show('cancel-plan-success')
        }
      } catch (e){
        this.error = true
        this.error_msg = e.message
      }
      this.submitting=false
    },
    cancel(){
      this.$bvModal.hide('cancel-user-plan')
    },
    checkCode(){
      console.log(this.canselCode);
      if (this.canselCode == '39') this.canselSubmit = true
      else this.canselSubmit = false

      console.log(this.canselSubmit);
    },
  },
  async mounted(){
    await Vue.nextTick()
  },
}
</script>
<style lang="scss" scoped>
</style>
